import type { CosignSupervisorsResponse } from "@/api/(requests)/permissionsTyped";
import { permissionsRequestsTyped } from "@/api/(requests)/permissionsTyped";

export async function getCosignSupervisors(): Promise<CosignSupervisorsResponse> {
  return permissionsRequestsTyped.get_cosign_supervisors();
}
